var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_white",
    "data-name": "Ellipse white",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_grey",
    "data-name": "Ellipse grey",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(5 5)",
    fill: "#e3e3e3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM6.253,16.771H3.442V7.725H6.253ZM4.848,6.489a1.63,1.63,0,1,1,1.629-1.63A1.63,1.63,0,0,1,4.848,6.489ZM16.782,16.771H13.973v-4.4c0-1.049-.019-2.4-1.461-2.4-1.462,0-1.687,1.143-1.687,2.322V16.77H8.016V7.725h2.7V8.961h.038A2.954,2.954,0,0,1,13.41,7.5c2.847,0,3.372,1.873,3.372,4.309v4.961Z",
    transform: "translate(5 5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.117f4c4cc0524a77cb43541471d5f3d2.svg";
export { ForwardRef as ReactComponent };